export function ignMenuInit (assetsUrl) {
  // force new ign menu on all env where we have beta menu
  window.forceIGN = true;

  const ignScript = document.createElement('script');
  ignScript.src = `https:${assetsUrl}/integrated-global-nav/2/loader.js`;
  document.head.appendChild(ignScript);
}
